module.exports = __webpack_public_path__ + "static/media/dividends.36eb69a0.svg";